import { computed, ref } from "vue";
import axios from "axios";
import { useUserStore, currentAuthEpoch, bumpAuthEpoch } from "../store/userStore";

const isLogin = ref<boolean>(true);
const isSignedIn = computed(() => isLogin.value && !!useUserStore().email);

// De-duplicates concurrent/back-to-back auth checks (e.g. a route helper and the
// router guard both firing on one navigation) so they share a single /user/me call.
let inflight: Promise<void> | null = null;

async function runCheckLoginStatus() {
  const userStore = useUserStore();
  const epoch = currentAuthEpoch();
  try {
    // Single /user/me round-trip: reuse the fetched payload to populate the store
    // instead of calling getUser(), which would fetch /user/me a second time.
    const res = await axios.get("/api/v1/user/me", { withCredentials: true });
    if (epoch !== currentAuthEpoch()) return;

    isLogin.value = true;
    userStore.setUserFromData(res.data);
  } catch (e: any) {
    if (epoch !== currentAuthEpoch()) return;
    console.warn("❌ Not logged in:", e?.response?.status);
    isLogin.value = false;

    // 如果登出或 cookie 失效，也可清空 store
    userStore.$reset?.();
  }
}

function checkLoginStatus(): Promise<void> {
  if (inflight) return inflight;

  const check = runCheckLoginStatus().finally(() => {
    if (inflight === check) inflight = null;
  });
  inflight = check;

  return check;
}

function markLoggedOut(): void {
  bumpAuthEpoch();
  inflight = null;
  isLogin.value = false;
  useUserStore().$reset?.();
}

export { isLogin, isSignedIn, checkLoginStatus, markLoggedOut };
